export function groupDetail() {
    $('.main-slider').slick({
        speed: 500,
        slidesToShow: 1,
        dots: true,
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed:3000,
    });
    $('.main-slider-wrapper .prev').click(function () {
        $('.main-slider').slick('slickPrev');
    });
    $('.main-slider-wrapper .next').click(function () {
        $('.main-slider').slick('slickNext');
    });

    $('.gallery-slider').slick({
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: true,
        arrows: true,
        infinite: false,
        nextArrow: '<button type="button" class="slick-next"></button>',
        prevArrow: '<button type="button" class="slick-prev"></button>',
        responsive: [
            {
                breakpoint: 667,
                settings: {
                    dots: true,
                    arrows: false,
                },
            },
        ],
        autoplay: true,
        autoplaySpeed:6000,

    });

    $('.cities select').change(function () {
        var targetSelect = $(this).val();
        $('.experience-selector select').removeClass('active');
        $('.experience-selector select#' + targetSelect).addClass('active');
    });

    if ($(window).width() < 667) {
        $('.single-info-holder h2').click(function () {
            $(this).parent().toggleClass('active');
        });
    }

    $('.callback-button').click(function(){
        gtag('event', this.dataset.event, {
            'event_category': 'Group Detail',
            'event_label': 'Tour',
            'value': this.dataset.tourtitle
        });
    });
}



// WEBPACK FOOTER //
// ./c:/Projects/UB/unlimitedbiking.com/wp-content/themes/unlimitedbiking/slice/assets/js/modules/groupDetail.js